import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as appointmentActions from 'yoda-site-components/lib/actions/AppointmentActions';
import * as sliderActions from 'yoda-site-components/lib/actions/AccountAction';
import * as rewardsActions from 'yoda-site-components/lib/actions/RewardsAction';
import * as paymentMethodsActions from '../../../../actions/PaymentMethodsActions';
import * as accountDetailsActions from '../../../../actions/AccountDetailsActions';
import * as addressActions from '../../../../actions/AddressActions';
import * as notificationDetailsActions from '../../../../actions/NotificationDetailsActions';
import * as addressingConstActions from '../../../../actions/AddressingConstActions';
import * as actions from '../../../../actions/CAMDashboardActions';
import MyHome from '../../../../components/MyHome/MyHome';

function mapStateToProps(state) {
    let rewardsDetails = {};
    if (state.rewardsDetails && state.rewardsDetails.details) {
        rewardsDetails = state.rewardsDetails.details;
    }
    return {
        accountDetails: state.accountDetails,
        addressDetails: state.addressDetails,
        paymentDetails: state.paymentDetails,
        addressingConstDetails: state.addressingConstDetails,
        rewardsDetails,
        missingPointsDetails: state.missingPoints,
        deviceType: state.context.deviceType,
        hostname: state.context.hostname ? state.context.hostname : {},
        signInDetails: state.signInDetails || {},
        appointmentDetails: get(state, 'appointmentDetails.allStores'),
        notificationDetails: state.notificationDetails || {},
        messagesTexts: state.context.messagesTexts,
        preferences: state.context.preferences,
        userProfile: get(state, 'accounts.userProfile', {}),
    };
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    rewardsActions: bindActionCreators(rewardsActions, dispatch),
    accountDetailsActions: bindActionCreators(accountDetailsActions, dispatch),
    addressActions: bindActionCreators(addressActions, dispatch),
    paymentMethodsActions: bindActionCreators(paymentMethodsActions, dispatch),
    appointmentActions: bindActionCreators(appointmentActions, dispatch),
    notificationDetailsActions: bindActionCreators(notificationDetailsActions, dispatch),
    addressingConstActions: bindActionCreators(addressingConstActions, dispatch),
    sliderActions: bindActionCreators(sliderActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyHome);
